export default "__VITE_ASSET__06de0288__"